import script from "./DocumentConstructorForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentConstructorForm.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentConstructorForm.vue?vue&type=style&index=0&id=337a4322&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

const __exports__ = script;

export default __exports__